import "styles/index.css";

import React from "react";

import Dropdown from "components/Dropdown";
import { Text, TextTitle } from "components/Texts";
import Button from "components/Buttons";
import _findIndex from "lodash/findIndex";

import styled from "styled-components";
import { useTranslation } from "react-i18next";

const AdsSelector = ({
  googleAdsList = [],
  facebookAdsList = [],
  onSelectGoogle,
  onSelectFacebook,
  onSaveAds,
  isSetting,
  connectedGoogleAds,
  connectedFacebookAds,
}) => {
  const [t] = useTranslation();
  const dropdownOptions = {
    defaultGoogle: 0,
    defaultFacebook: 0,
    disableGoogle: false,
    disableFacebook: false,
  };

  if (isSetting) {
    if (googleAdsList.length > 1 && connectedGoogleAds) {
      dropdownOptions.defaultGoogle = _findIndex(googleAdsList, ["value", connectedGoogleAds.value]);
    } else if (googleAdsList.length <= 1) {
      dropdownOptions.disableGoogle = true;
    }

    if (facebookAdsList.length > 1 && connectedFacebookAds) {
      dropdownOptions.defaultFacebook = _findIndex(facebookAdsList, ["value", connectedFacebookAds.value]);
    } else if (facebookAdsList.length <= 1) {
      dropdownOptions.disableFacebook = true;
    }
  }

  console.log("AdsSelector", connectedGoogleAds, connectedFacebookAds, dropdownOptions);

  return (
    <StyledContainer>
      {!isSetting && <TextTitle className="title">{t("__setup_ads")}</TextTitle>}
      {googleAdsList.length ? (
        <>
          <Text className="label">{t("__google_ads")}</Text>
          <Dropdown
            key={`g_${dropdownOptions.defaultGoogle}`}
            items={googleAdsList}
            onSelected={onSelectGoogle}
            minWidth="268px"
            defaultIndex={dropdownOptions.defaultGoogle}
            disabled={dropdownOptions.disableGoogle}
          />
        </>
      ) : null}
      {facebookAdsList.length ? (
        <>
          <Text className="label">{t("__facebook_ads")}</Text>
          <Dropdown
            key={`f_${dropdownOptions.defaultFacebook}`}
            items={facebookAdsList}
            onSelected={onSelectFacebook}
            minWidth="268px"
            defaultIndex={dropdownOptions.defaultFacebook}
            disabled={dropdownOptions.disableFacebook}
          />
        </>
      ) : null}
      {!isSetting && (
        <Button onClick={onSaveAds} disabled={dropdownOptions.disableGoogle && dropdownOptions.disableFacebook} full>
          {t("__save")}
        </Button>
      )}
    </StyledContainer>
  );
};

export default AdsSelector;

const StyledContainer = styled.div`
  .title {
    text-align: center;
    margin-bottom: 16px;
  }

  .label {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .value {
    margin: 0 0 16px;
  }

  .dropdown-button {
    margin-bottom: 24px;
  }
`;
